export default "__VITE_ASSET__BRG2J8dn__"